import React, { useEffect, useState } from 'react';

const SPLASH_IMAGE =
  'https://customer-assets.emergentagent.com/job_booking-hub-427/artifacts/f5h7lu3v_ZB-14.jpg';

export default function AgeGate() {
  const [accepted, setAccepted] = useState(true);
  const [loaded, setLoaded] = useState(false);

  useEffect(() => {
    const ok = sessionStorage.getItem('zb_age_ok');
    const forced = new URLSearchParams(window.location.search).get('entry');
    if (forced === '1') {
      sessionStorage.removeItem('zb_age_ok');
      // Also clear any legacy long-lived flag from before this change
      localStorage.removeItem('zb_age_ok');
      setAccepted(false);
      return;
    }
    if (ok !== 'yes') setAccepted(false);
  }, []);

  useEffect(() => {
    if (!accepted) {
      document.body.style.overflow = 'hidden';
    } else {
      document.body.style.overflow = '';
    }
    return () => { document.body.style.overflow = ''; };
  }, [accepted]);

  const accept = () => {
    sessionStorage.setItem('zb_age_ok', 'yes');
    // Clean up any legacy long-lived flag
    localStorage.removeItem('zb_age_ok');
    setAccepted(true);
  };

  const exit = () => {
    window.location.href = 'https://www.google.com';
  };

  if (accepted) return null;

  return (
    <div data-testid="age-gate-modal" className="fixed inset-0 z-[100] bg-zb-ink">
      {/* Background image */}
      <img
        src={SPLASH_IMAGE}
        alt=""
        onLoad={() => setLoaded(true)}
        className={`zb-agegate-image absolute inset-0 w-full h-full object-cover transition-opacity duration-[1400ms] ease-out ${
          loaded ? 'opacity-100' : 'opacity-0'
        }`}
      />
      {/* Warm gradient veil for legibility */}
      <div
        className="absolute inset-0"
        style={{
          background:
            'linear-gradient(180deg, rgba(44,40,37,0.35) 0%, rgba(44,40,37,0.15) 40%, rgba(44,40,37,0.65) 100%)',
        }}
      />

      {/* Top meta */}
      <div className="relative z-10 flex items-center justify-between px-6 md:px-12 pt-8 text-zb-bg/85">
      </div>

      {/* Center content */}
      <div className="relative z-10 h-[calc(100vh-7rem)] flex flex-col items-center justify-center px-6 text-center">
        <div className="zb-fade-up">
          <h1
            className="font-serif text-zb-bg leading-[0.9] tracking-tight"
            style={{ fontSize: 'clamp(72px, 14vw, 200px)' }}
          >
            Zahra <span className="italic" style={{ color: '#E9D8C9' }}>Belle</span>
          </h1>
          <p className="mt-8 font-serif italic text-zb-bg/90 text-xl md:text-2xl max-w-xl mx-auto">
            Exactly what you&rsquo;ve been missing.
          </p>
        </div>

        <div className="mt-14 md:mt-16 zb-fade-up zb-delay-2 flex flex-col items-center gap-6">
          <button
            data-testid="age-gate-accept-button"
            onClick={accept}
            className="group relative overflow-hidden rounded-full bg-zb-bg text-zb-ink hover:bg-zb-brand hover:text-zb-bg px-12 py-4 text-xs tracking-[0.3em] uppercase transition-colors duration-500"
          >
            Come inside · 18+
          </button>
          <button
            data-testid="age-gate-exit-button"
            onClick={exit}
            className="text-zb-bg/75 hover:text-zb-bg text-[11px] tracking-[0.22em] uppercase underline underline-offset-4 transition-colors"
          >
            I am under 18 · Exit
          </button>
        </div>
      </div>

      {/* Bottom bar */}
      <div className="absolute bottom-0 inset-x-0 z-10 px-6 md:px-12 pb-6 text-zb-bg/75">
        <div className="zb-hairline mb-4" style={{ background: 'rgba(249,248,246,0.25)' }} />
        <div className="flex items-center justify-center sm:justify-end font-label text-[10px]">
          <span>By entering, you confirm you are of legal age in your jurisdiction.</span>
        </div>
      </div>
    </div>
  );
}
